import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchZoneCategories = brands => dispatch =>
  get('/zone-categories', {
    pagination: false,
    selectInBrands: brands,
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  }).then(response => {
    dispatch({
      type: types.FETCH_ZONE_CATEGORIES,
      payload: {
        zoneCategories: response['hydra:member'],
      },
    });
  });

export const fetchZoneCategory = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/zone-categories/${id}`).then(response => {
    dispatch({
      type: types.FETCH_ZONE_CATEGORY,
      payload: {
        name: response.name,
      },
    });
    return response;
  });

export const removeZoneCategory = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/zone-categories/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_ZONE_CATEGORY,
      payload: {
        zoneCategoryId: id,
      },
    });
  });
